import { useHeader } from "providers";

export default function HeaderViewModel() {
  const { header } = useHeader();

  return { header };
}
